import { useState } from "react";
import { Input, Tooltip, DatePicker } from "antd";
import clsx from "clsx";
import type { Dayjs } from "dayjs";
import { SearchIcon, InfoIcon, CalendarIcon } from "@/shared/assets/svg/icons";
import { InputSelect } from "@shared/ui";
import "./supervision-notifications-filter.scss";

interface SupervisionNotificationsFilterProps {
  isFullWidth?: boolean;
  searchValue: string;
  onSearchChange: (value: string) => void;
  selectedDate?: Dayjs | null;
  onDateChange?: (date: Dayjs | null) => void;
}

export const SupervisionNotificationsFilter = ({
  isFullWidth,
  searchValue,
  onSearchChange,
  selectedDate,
  onDateChange,
}: SupervisionNotificationsFilterProps) => {
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);

  const handleCalendarClick = () => {
    setIsCalendarOpen(true);
  };

  const handleDateChange = (date: Dayjs | null) => {
    if (date && selectedDate && date.isSame(selectedDate, "day")) {
      onDateChange?.(null);
    } else {
      onDateChange?.(date);
    }
    setIsCalendarOpen(false);
  };
  return (
    <div
      className={clsx(
        "supervision-projects-filters",
        "supervision-notifications-filter",
        isFullWidth && "supervision-notifications-filter--full-width",
      )}
    >
      <div className="flex-default">
        <Input
          className="project-members-search"
          suffix={<SearchIcon />}
          placeholder="Поиск по названию документа"
          onChange={(e) => onSearchChange(e.target.value)}
          value={searchValue}
          style={{ width: "240px", marginRight: "4px" }}
        />
        <Tooltip
          title="Поиск по ключевым словам, адресу, названиям документов и ГСН"
          placement="top"
          arrow={false}
        >
          <span className="project-members-search-tooltip">
            <InfoIcon />
          </span>
        </Tooltip>
      </div>
      <div className="flex-default">
        <div className="supervision-notifications-filter__calendar-wrap">
          <div
            className={clsx(
              "supervision-notifications-filter__calendar-trigger",
              selectedDate && "supervision-notifications-filter__calendar-trigger--selected",
            )}
            onClick={handleCalendarClick}
          >
            <CalendarIcon />
          </div>
          <DatePicker
            value={selectedDate}
            onChange={handleDateChange}
            open={isCalendarOpen}
            onOpenChange={setIsCalendarOpen}
            className="supervision-notifications-filter__hidden-picker"
            format="DD.MM.YYYY"
            placeholder="Выберите дату"
            getPopupContainer={() => document.body}
            allowClear={false}
          />
        </div>
        <InputSelect
          title="По дате"
          style={{ marginRight: "8px", marginLeft: "12px" }}
          statuses={[
            {
              id: "new",
              status: "Сначала новые",
              icon: <></>,
            },
            {
              id: "old",
              status: "Сначала старые",
              icon: <></>,
            },
          ]}
          selectedStatus={null}
          setSelectedStatus={() => {
            return null;
          }}
        />
        <InputSelect
          title="Тип процесса"
          style={{ marginRight: "8px" }}
          statuses={[
            {
              id: "type1",
              status: "Тип процесса 1",
              icon: <></>,
            },
            {
              id: "type2",
              status: "Тип процесса 2",
              icon: <></>,
            },
          ]}
          selectedStatus={null}
          setSelectedStatus={() => {
            return null;
          }}
        />
        <InputSelect
          title="Статус"
          style={{ marginRight: "8px" }}
          statuses={[
            {
              id: "ALL",
              status: "Все",
              icon: <></>,
            },
            {
              id: "new",
              status: "Новые",
              icon: <></>,
            },
            {
              id: "rejected",
              status: "Отклонены",
              icon: <></>,
            },
            {
              id: "received",
              status: "Получено из органа надзора",
              icon: <></>,
            },
          ]}
          selectedStatus={null}
          setSelectedStatus={() => {
            return null;
          }}
        />
      </div>
    </div>
  );
};
